import { addToSet } from "../fable-library.3.7.17/MapUtil.js";
import { createAnimation, createFontFace, createFontFaces, createCounterStyle, createGlobal, createFss } from "../Fss-lib.Core.1.0.4/Functions.fs.js";
import { join } from "../fable-library.3.7.17/String.js";
import { map } from "../fable-library.3.7.17/List.js";

function processCssRule(name, rule) {
    return `${name} ${rule}`;
}

const styleCache = new Set([]);

function injectCss(className, css) {
    if (styleCache.has(className)) {
    }
    else {
        const head = document.getElementsByTagName("head")[0];
        const style = document.createElement("style");
        style.setAttribute("type", "text/css");
        style.appendChild(document.createTextNode(css));
        head.appendChild(style);
        addToSet(className, styleCache);
    }
}

export function fss(properties) {
    const patternInput = createFss(properties);
    const className = patternInput[0];
    injectCss(className, join("", map((tupledArg) => processCssRule(tupledArg[0], tupledArg[1]), patternInput[1])));
    return className;
}

export function global$0027(properties) {
    injectCss("*", join("", map((tupledArg) => processCssRule(tupledArg[0], tupledArg[1]), createGlobal(properties))));
}

function processCounterRules(name, rules) {
    return `@counter-style ${name} ${rules}`;
}

export function counterStyle(properties) {
    const patternInput = createCounterStyle(properties);
    const counterName = patternInput[0];
    injectCss(counterName, processCounterRules(counterName, patternInput[1]));
    return counterName;
}

function processFontFaceRules(rules) {
    return `@font-face ${rules}`;
}

export function fontFaces(name, properties) {
    const patternInput = createFontFaces(name, properties);
    const fontName = patternInput[0];
    injectCss(fontName, processFontFaceRules(patternInput[1]));
    return fontName;
}

export function fontFace(name, properties) {
    const patternInput = createFontFace(name, properties);
    const fontName = patternInput[0];
    injectCss(fontName, processFontFaceRules(patternInput[1]));
    return fontName;
}

function processAnimationRules(name, rules) {
    return `@keyframes ${name} ${rules}`;
}

export function keyframes(properties) {
    const patternInput = createAnimation(properties);
    const animationName = patternInput[0];
    injectCss(animationName, processAnimationRules(animationName, patternInput[1]));
    return animationName;
}

